import React from 'react'
import icon from './svgs/coursetick.svg'
import { BaseIcon } from './_base'

export const CourseTickIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
